export enum CompanyEnum {
    BRF = 'BRF',
    MARFRIG = 'MARFRIG',
}
